import loadable from "@loadable/component";
//@ts-ignore
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
const ContractComponent = loadable(
  () => import("../../components/Contacts/Contact")
);

const Contact = () => {
  const { data, isLoading } = useGetHook({
    queryKey: ["contact-groups"],
    url: APIS.CONTACT_GROUP,
    params: { is_default: true },
  });
  return <>{isLoading ? <Spinner /> : <ContractComponent data={data} />}</>;
};

export default Contact;
